import { store } from "../../store";
import { plainToClass } from 'class-transformer'
import { ListApplicationVersionsDTO } from '../../dto/application-versions'
import { validate } from 'class-validator'

export const listApplicationVersions = async ( page: number = 1 ) => {

    let body, response
    const { orderBy, orderDirection } = store.getState().applicationVersions

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/application-versions?page=${ page }&orderBy=${ orderBy }&orderDirection=${ orderDirection }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_APPLICATION_VERSIONS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'LIST_APPLICATION_VERSIONS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'LIST_APPLICATION_VERSIONS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( ListApplicationVersionsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_APPLICATION_VERSIONS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'LIST_APPLICATION_VERSIONS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'LIST_APPLICATION_VERSIONS_OK', applicationVersions: body.applicationVersions, pagination: body.pagination } )

}